import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed } from "vue";
import { trans } from "laravel-vue-i18n";
import { FormInput, FormRadio, Submit } from "@/ts/components/form";
import { useForm } from "vee-validate";
import * as Yup from "yup";
import { useReCaptcha } from "vue-recaptcha-v3";
import { useErrors } from "@/ts/utils/api-functions";


export default /*#__PURE__*/_defineComponent({
  emits: ["submit", "back", "mounted"],
  setup(__props, { expose, emit }) {
  expose();

const component = ref<HTMLDivElement>();


const success = ref(false);
const loading = ref(false);
const reCaptcha = useReCaptcha();
const apiErrors = useErrors();

const schema = computed(() =>
    Yup.object({
        reason: Yup.string().oneOf(["reason_1", "reason_2", "reason_3", "reason_4"]),
        comment: Yup.string().optional(),
    }),
);

const { handleSubmit, meta } = useForm({
    initialValues: { reason: "", comment: "" },
    validationSchema: schema,
});

onMounted(() => {
    emit("mounted", component.value!.offsetHeight);

    onMounted(() => {
        window.addEventListener("resize", () => {
            emit("mounted", component.value!.offsetHeight);
        });

        window.addEventListener("orientationchange", () => {
            emit("mounted", component.value!.offsetHeight);
        });
    });
});

const onSubmit = handleSubmit(async (values, { resetForm }) => {
    loading.value = true;
    try {
        await reCaptcha!.recaptchaLoaded();
        const token = await reCaptcha!.executeRecaptcha("login");
        success.value = true;
        emit("submit", values);
    } catch (error) {
        apiErrors.parse(error);
    } finally {
        loading.value = false;
    }
});

const __returned__ = { component, emit, success, loading, reCaptcha, apiErrors, schema, handleSubmit, meta, onSubmit, trans, FormInput, FormRadio, Submit }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})